/* eslint-disable import/no-cycle */
// @ts-nocheck
/* eslint-disable react/forbid-component-props */
/* eslint-disable react/prop-types */
import {
  Typography,
  Box,
  IconButton,
  Dialog,
  Paper,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import React, { useState, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import Editor from '@monaco-editor/react';
import { DIALOG_ICON_BUTTON_CSS } from '../../../const/CommonConst';
import { ReactComponent as CodeIcon } from '../../../assets/images/Code.svg';
import CommentBox from '../../Common/CommentBox';
import { ReactComponent as CommentButtonIcon } from '../../../assets/images/CommentIcon.svg';
import { ReactComponent as CommentButtonIconDisabled } from '../../../assets/images/CommentIconDisabled.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/images/DownloadIcon.svg';
import { ReactComponent as ExpandWindowIcon } from '../../../assets/images/ExpandWindowIcon.svg';
import { ReactComponent as ExternalLink } from '../../../assets/images/external-link.svg';
import { ReactComponent as CollapseWindowIcon } from '../../../assets/images/CollapseWindowIcon.svg';
import SwalToast from '../../Common/SwalToast';
import AddResultToModelMetaDataModal from '../../Common/AddResultToModelMetaDataModal';
import { ModelMonitoringDashboardIcon } from '../../../const/CommonIcons';
import ModelMonitoringDashboardDialog from '../../../views/ModelMonitoringDashboard/ModelMonitoringDashboardDialog';
import MODULE_SUB_MODULE_OPERATIONS_TREE from '../../../const/ModuleSubModuleOperationsTree';
import SaveChartandTableInDocumentationModal from '../../NewDocumentation/SaveChartandTableInDocumentationModal';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper {...props} />
    </Draggable>
  );
}

const editorTheme = 'myThemeDark';
const UNAUTHORIZED_MESSAGE = 'You are not authorized to access this!';
const PROJECT_COMPLETED = 'Project has been marked completed.';
const IframeContainer = ({
  codeSnippet,
  url,
  commentid,
  // commenttableName,
  showCommentBox = true,
  key,
  moduleName,
  isConsole = false,
  dialogOpen,
  handleDialogOpen,
  graphData,
  setGraphData,
  chartHeader,
  handleDialogClose,
  zoomResultImg = 1,
  permission,
  onAddChartClick,
  activeProject,
  subModuleName,
  addResultToModelMetaData,
  modelMetaDataSchema,
  b64,
  modelMonitioringDashboardPermission,
}) => {
  const { permissions } = useSelector((state) => state?.user);
  const commentOnResultsPermission =
    permissions[
      `${MODULE_SUB_MODULE_OPERATIONS_TREE?.AD?.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE?.AD?.subModules?.CR?.key}`
    ];
  const [openGraphComment, setOpenGraphComment] = useState(false);
  const [openAddToModelMetaData, setOpenAddToModelMetaData] = useState(false);
  const [openCode, setOpenCode] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const showAddToModelMetaDataOption = React.useMemo(
    () =>
      addResultToModelMetaData &&
      activeProject?.system_generated_flag &&
      activeProject?.system_name === 'Vault',
    [addResultToModelMetaData, activeProject]
  );

  const monacoRef = useRef(null);

  const handleEditorDidMount = (monaco) => {
    monacoRef.current = monaco;

    monaco.editor.defineTheme('myThemeDark', {
      base: 'vs-dark',
      inherit: true,
      rules: [
        { token: 'comment', foreground: 'ffa500' },
        { token: 'keyword', foreground: '00ff00' },
        { token: 'string', foreground: 'FF4D4D' },
      ],
      colors: {
        'editor.foreground': '#AECDFC',
        'editor.background': '#141A3F',
        'dropdown.background': '#000000',
        'dropdown.border': '#000000',
        'editorGutter.foldingControlForeground': '#ffffff',
        'editorLineNumber.activeForeground': '#000000',
        'editorLineNumber.foreground': '#525252',
        'editorGutter.background': '#BFDAFC',
        'scrollbarSlider.background': '#AECDFC',
        'scrollbarSlider.activeBackground': '#AECDFC',
        'scrollbarSlider.hoverBackground': '#AECDFC',
      },
    });
  };

  /**
   * @function downloadChartFile
   * @description It is to download the chart file
   * @param {string} filename
   * @returns {void}
   * @example downloadChartFile filename={filename}
   */
  const downloadChartFile = React.useCallback((filename = 'chart') => {
    const link = document.createElement('a');
    link.href = `data:image/png;base64,${b64}`;
    link.download = `${filename}.png`;
    link.click();
  }, []);

  /**
   * @function handleCodeBoxOpen
   * @description When the condition satisfied it change the state from null to true
   * @param {string} value
   * @returns {void}
   * @example handleCodeBoxOpen value={value}
   */
  const handleCodeBoxOpen = (value) => {
    if (value === 'Graph') {
      setOpenCode(true);
    }
  };

  /**
   * @function handleCodeBoxClose
   * @description It change the state from null to false
   * @returns {void}
   * @example handleCodeBoxOpen value={value}
   */
  const handleCodeBoxClose = useCallback(() => {
    setOpenCode(false);
  }, [setOpenCode]);

  /**
   * @function handleCommentBoxOpen
   * @description When the condition satisfied it change the state from null to true
   * @param {string} value
   * @returns {void}
   * @example handleCommentBoxOpen value={value}
   */
  const handleCommentBoxOpen = (value) => {
    if (value === 'Graph') {
      setOpenGraphComment(true);
    }
  };

  /**
   * @function handleCommentBoxClose
   * @description It change the state from null to false
   * @returns {void}
   * @example handleCommentBoxClose value={value}
   */
  const handleCommentBoxClose = useCallback(() => {
    setOpenGraphComment(false);
  }, [setOpenGraphComment]);

  const handleAddToModelMetaDataModalClose = useCallback(() => {
    setOpenAddToModelMetaData(false);
  }, [setOpenAddToModelMetaData]);

  const addChartInMonitoring = React.useCallback(
    (payloadData) => {
      if (b64) {
        const chartDataPayload = {
          ...payloadData,
          type: 'chart',
          url: b64,
          project_id: activeProject?.project_id,
        };
        onAddChartClick(chartDataPayload).then((res) => {
          SwalToast({
            icon: 'success',
            title: res.data?.msg,
          });
        });
      }
    },
    [b64]
  );

  const handleGraphClick = useCallback(() => {
    handleDialogOpen();
    setGraphData({ ...graphData, type: 'chart' });
  }, [handleDialogOpen, setGraphData, graphData]);
  const handleModelMonitoringIconClick = useCallback(() => {
    setOpenDialog(true);
  }, [setOpenDialog]);

  const handleDownload = useCallback(() => {
    downloadChartFile(chartHeader);
  }, [chartHeader]);

  const handleCodeIconClick = useCallback(() => {
    handleCodeBoxOpen('Graph');
  }, [handleCodeBoxOpen]);

  const handleCommentIconClick = useCallback(() => {
    handleCommentBoxOpen('Graph');
  }, [handleCommentBoxOpen]);

  const handleCustomizeIconClick = useCallback(() => {
    addChartInMonitoring(graphData);
  }, [addChartInMonitoring, graphData]);

  const handleModelTrainingIconClick = useCallback(() => {
    setOpenAddToModelMetaData(true);
  }, [setOpenAddToModelMetaData]);

  const handleCollapseIconClick = useCallback(() => {
    handleDialogClose();
  }, [handleDialogClose]);

  const commentOnResultsTitle = React.useMemo(() => {
    switch (true) {
      case activeProject?.is_completed === true:
        return PROJECT_COMPLETED;

      case commentOnResultsPermission !== 'Yes':
        return UNAUTHORIZED_MESSAGE;

      default:
        return 'Add comment';
    }
  }, [commentOnResultsPermission, activeProject?.is_completed]);

  const modelMonitioringDashboardTitle = React.useMemo(() => {
    switch (true) {
      case activeProject?.is_completed === true:
        return PROJECT_COMPLETED;

      case modelMonitioringDashboardPermission === 'No':
        return UNAUTHORIZED_MESSAGE;

      default:
        return 'Add to model monitoring dashboard';
    }
  }, [modelMonitioringDashboardPermission, activeProject?.is_completed]);

  const addToVaultTitle = React.useMemo(() => {
    switch (true) {
      case activeProject?.is_completed === true:
        return PROJECT_COMPLETED;

      case !['Manage', 'Yes'].includes(permission):
      case modelMetaDataSchema?.Details_UpdateAttribute === 'No':
        return UNAUTHORIZED_MESSAGE;

      default:
        return 'Add to vault';
    }
  }, [permission, activeProject?.is_completed, modelMetaDataSchema]);

  const handleOpenInNewTab = useCallback(() => {
    const URL = graphData?.url;
    window.open(URL, '_blank');
  }, [graphData?.url]);

  return (
    <Box
      display="flex"
      sx={{ flexDirection: 'column', paddingY: 1.5, paddingX: 3 }}
      height="inherit"
    >
      <Box display="flex" flexDirection="column">
        <Box
          mb={0}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          sx={{ mb: 2 }}
        >
          <Box mt={1} ml={1}>
            <Typography
              variant="h4"
              component="h1"
              tabIndex={0}
              sx={(theme) => ({
                '&:focus-visible': {
                  outline: 'none',
                  border: `2px solid ${theme?.palette?.primary?.main} !important`,
                },
              })}
            >
              {chartHeader}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="flex-end" flexGrow={1}>
            <IconButton
              onClick={handleOpenInNewTab}
              aria-label="Open in new tab"
            >
              <ExternalLink title="Open in new tab" />
            </IconButton>
            <IconButton
              color="primary"
              // eslint-disable-next-line
              onClick={handleDownload}
              aria-label="Download"
            >
              <DownloadIcon title="Download" />
            </IconButton>
            {codeSnippet && (
              <IconButton
                // eslint-disable-next-line
                onClick={handleCodeIconClick}
                aria-label="Code snippet"
              >
                <CodeIcon title="Code snippet" />
              </IconButton>
            )}
            {showCommentBox && (
              <IconButton
                // eslint-disable-next-line
                onClick={handleCommentIconClick}
                title={commentOnResultsTitle}
                aria-label={commentOnResultsTitle}
                disabled={commentOnResultsPermission !== 'Yes'}
                color="primary"
              >
                {commentOnResultsPermission === 'Yes' ? (
                  <CommentButtonIcon />
                ) : (
                  <CommentButtonIconDisabled />
                )}
              </IconButton>
            )}
            {onAddChartClick && (
              <IconButton
                color="primary"
                // eslint-disable-next-line
                onClick={handleCustomizeIconClick}
                disabled={
                  modelMonitioringDashboardPermission === 'No' ||
                  activeProject?.is_completed === true
                }
                title={modelMonitioringDashboardTitle}
                aria-label={modelMonitioringDashboardTitle}
              >
                <DashboardCustomizeIcon />
              </IconButton>
            )}
            {onAddChartClick && (
              <IconButton
                onClick={handleModelMonitoringIconClick}
                color="primary"
                aria-label={
                  modelMonitioringDashboardPermission === 'No'
                    ? UNAUTHORIZED_MESSAGE
                    : 'Model monitoring dashboard'
                }
                disabled={modelMonitioringDashboardPermission === 'No'}
                title={
                  modelMonitioringDashboardPermission === 'No'
                    ? UNAUTHORIZED_MESSAGE
                    : 'Model monitoring dashboard'
                }
              >
                <ModelMonitoringDashboardIcon width={20} height={20} />
              </IconButton>
            )}
            {showAddToModelMetaDataOption ? (
              <IconButton
                color="primary"
                onClick={handleModelTrainingIconClick}
                disabled={
                  !['Manage', 'Yes'].includes(permission) ||
                  modelMetaDataSchema?.Details_UpdateAttribute === 'No'
                }
                title={addToVaultTitle}
                aria-label={addToVaultTitle}
              >
                <ModelTrainingIcon />
              </IconButton>
            ) : null}
            {!dialogOpen ? (
              <IconButton
                title="Expanded view"
                onClick={handleGraphClick}
                size="small"
                aria-label="Expand view"
              >
                <ExpandWindowIcon />
              </IconButton>
            ) : (
              <IconButton
                onClick={handleCollapseIconClick}
                size="small"
                aria-label="Collapse View"
              >
                <CollapseWindowIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      </Box>
      <Box height="inherit">
        <Box width="100%" height="100%" sx={{ zoom: `${zoomResultImg}` }}>
          <embed
            id="iframe_graph"
            key={key}
            src={url}
            style={{ width: '100%', height: '100%' }}
          />
        </Box>
      </Box>
      {showCommentBox &&
        openGraphComment &&
        (window.CONFIG.NEW_DOCUMENTATION === 'false' ? (
          <CommentBox
            handleCommentBoxClose={handleCommentBoxClose}
            b64={b64}
            openDialog={openGraphComment}
            id={commentid}
            type="chart"
            moduleName={moduleName}
            subModuleName={subModuleName}
            isConsole={isConsole}
          />
        ) : (
          <SaveChartandTableInDocumentationModal
            handleCommentBoxClose={handleCommentBoxClose}
            open={openGraphComment}
            onClose={handleCommentBoxClose}
            id={commentid}
            data={b64}
            type="chart"
            activeProject={activeProject}
          />
        ))}

      {openCode && (
        <Dialog
          fullWidth={true}
          maxWidth="md"
          PaperComponent={PaperComponent}
          open={openCode}
          onClose={handleCodeBoxClose}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle id="draggable-dialog-title">Code Snippet</DialogTitle>
          <IconButton
            id="mui_cmp_cust_drag_dialog_title_close_btn"
            className="mui-dialog-close-icon-btn"
            color="primary"
            aria-label="Close"
            title="close"
            onClick={handleCodeBoxClose}
            size="large"
            sx={DIALOG_ICON_BUTTON_CSS}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <div
              aria-live="polite"
              role="alert"
              style={{
                width: '0px',
                height: '0px',
                overflow: 'hidden',
              }}
            >
              The content in editor is read only.
            </div>
            <Editor
              height="50vh"
              defaultLanguage="python"
              defaultValue={codeSnippet}
              theme={editorTheme}
              beforeMount={handleEditorDidMount}
              options={{
                padding: {
                  left: 12,
                  right: 12,
                  top: 12,
                  bottom: 12,
                },
                readOnly: true,
                fontSize: 16,
                lineHeight: 22,
                fontFamily: 'Open Sans',
                lineDecorationsWidth: 5,
                scrollbar: {
                  vertical: 'auto',
                  horizontal: 'auto',
                  verticalScrollbarSize: 5,
                  horizontalScrollbarSize: 5,
                },
              }}
              aria-label="Read-only code editor displaying a Python code snippet"
            />
          </DialogContent>
        </Dialog>
      )}

      {openDialog && (
        <ModelMonitoringDashboardDialog
          setOpenDialog={setOpenDialog}
          openDialog={openDialog}
        />
      )}
      {showAddToModelMetaDataOption ? (
        <AddResultToModelMetaDataModal
          open={openAddToModelMetaData}
          onClose={handleAddToModelMetaDataModalClose}
          addResultToModelMetaData={addResultToModelMetaData}
          modelMetaDataSchema={modelMetaDataSchema}
          activeProject={activeProject}
          resultContents={b64}
          resultType="chart"
        />
      ) : null}
    </Box>
  );
};

export default IframeContainer;
